export default __webpack_public_path__ + "static/media/PierceStgWeakIcon.883dd129.png";